import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';

const moment = require('moment');

class Navbar extends Component {

    render() {
       
     
        if (this.props.patient._id === undefined ) {
            return (
                <div>
                    <ul className='sidebar'>
                        
                    </ul>
                </div>
            )
        }
        else {
            const patientAge = moment(this.props.patient.dob).fromNow(true);
            return (
                <div>
                    <ul className="sidebar">
                        <li><div className='profile'>
                            {this.props.patient.title} 
                            {this.props.patient.firstname} {this.props.patient.lastname} <br />
                            {patientAge} old <br />
                            {this.props.patient.gender} <br />
                            <br />
                            
                            </div>
                        </li>
                        <li>
                            <Link to='/' >
                            <div className='navmenu'>
                                    <div><i class="fas fa-user-circle"></i></div>
                                    <div>Select Other Patient</div>
                            </div>   
                            </Link>
                        </li>
                        <br />< br/>
                        <li>
                            <Link to={`/summary/${this.props.patient._id}`} >
                            <div className='navmenu'>
                                    <div><i className="far fa-list-alt "></i></div>
                                    <div>Summary</div>
                            </div>   
                            </Link>
                        </li>
                        <br />< br/>
                        <div style={{padding:'5px', backgroundColor:'rgb(50, 61, 72)'}}>
                        Community Care Plan
                        <li>
                            <Link to={`/ChronicDisease/${this.props.patient._id}`} >
                            <div className='navmenu'>
                                    <div><i className="fas fa-heartbeat"></i></div>
                                    <div>Chronic Disease</div>
                            </div>   
                            </Link>
                        </li>
                        <li>
                            <Link to={`/MentalHealth/${this.props.patient._id}`} >
                            <div className='navmenu'>
                                    <div><i className="fas fa-brain" /></div>
                                    <div>Mental Health</div>
                            </div>   
                            </Link>
                        </li>
                        <li>
                            <Link to={`/HealthAssessment/${this.props.patient._id}`} >
                            <div className='navmenu'>
                                    <div><i className="fas fa-stethoscope"></i></div>
                                    <div>Health Assessment</div>
                            </div>   
                            </Link>
                        </li>
                        <li>
                            <Link to={`/Photo/${this.props.patient._id}`} >
                            <div className='navmenu'>
                                    <div><i className="fas fa-image"></i></div>
                                    <div>Photos</div>
                            </div>   
                            </Link>
                        </li>
                        <li>
                            <Link to={`/Pain/${this.props.patient._id}`} > 
                            <div className='navmenu'>
                                <div><i class="fas fa-bolt"></i></div>
                                <div>Pain Management</div>
                            </div>
                            </Link>
                        </li>
                        <li>
                            <Link to={`/Palliative/${this.props.patient._id}`} > 
                            <div className='navmenu'>
                                <div><i class="fas fa-dove"></i></div>
                                <div>Palliative Care</div>
                            </div>
                            </Link>
                        </li>
                        <li>
                            <Link to={`/AOD/${this.props.patient._id}`} > 
                            <div className='navmenu'>
                                <div><i class="fas fa-wine-bottle"></i></div>
                                <div>Drugs and Alcohol</div>
                            </div>
                            </Link>
                        </li>
                        </div>
                    </ul>
                </div>
            )
        }
    }
}

const mapStateToProps = (state) => {

    return { 
             patient : state.selectedPatient,
            };
}

export default connect(mapStateToProps)(Navbar);
